<template>
    <div class="content-header">
        <div class="row">
            <div class="col-md-6">
                <div class="header-section" v-if="routeRecords.length > 0">
                    <h1>
                        <template v-for="(routeObject, index) in routeRecords">
                            <span :key="index">
                                {{getName(routeObject)}}
                                <span v-if="index != routeRecords.length - 1">
                                    -
                                </span>
                            </span>
                        </template>
                    </h1>
                </div>
            </div>
            <div class="col-md-6 hidden-xsd-none d-sm-block">
                <div class="header-section">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item" :key="index" v-for="(routeObject, index) in routeRecords">
                            <span class="active" v-if="isLast(index)">{{ getName(routeObject) }}</span>
                            <router-link :to="routeObject" v-else>{{ getName(routeObject) }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Breadcrumb',
    data: () => {
        return {
            
        }
    },
    props: {
        list: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        routeRecords: function () {
            return this.list.filter((route) => route.name || route.meta.label)
        }
    },
    methods: {
        getName (item) {
            return item.meta && item.meta ? item.meta.label : item.name || null
        },
        isLast (index) {
            return index === this.list.length - 1
        }
    },
    watch: {
        
    }
}
</script>